import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmComponent } from './components/confirm/confirm.component';
import { ImageComponent } from './components/image/image.component';
import { LoadingComponent } from './components/loading/loading.component';
import { MaterialModule } from './material-module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxUploaderModule } from 'ngx-uploader';
import { TranslateComponent } from './components/translate/translate.component';
import { LanguageTranslationComponent } from './components/language-translation/language-translation.component';
import { UploadComponent } from './components/upload/upload.component'; 
import { CorizeEnvironment } from './models/corize-environment';   
import { HasPermissionDirective } from './directives/has-permissions.directive'; 
import { MenuComponent } from './components/menu/menu.component';
import { EnumToArrayPipe } from './pipes/enum-to-array';

 
@NgModule({
  declarations: [
    ConfirmComponent,
    LoadingComponent,
    ImageComponent,
    UploadComponent,
    TranslateComponent,
    LanguageTranslationComponent, 
    MenuComponent,
    HasPermissionDirective,
    EnumToArrayPipe
  ],
  imports: [    
    TranslateModule,
    MaterialModule,
    CommonModule,    
    NgxUploaderModule,
    BrowserModule, 
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    ConfirmComponent,
    LoadingComponent,
    ImageComponent,
    UploadComponent,
    MaterialModule,
    NgxUploaderModule,
    TranslateComponent,
    HasPermissionDirective,
    MenuComponent,
    LanguageTranslationComponent ,
    EnumToArrayPipe
  ]  ,
  providers:[
    CorizeEnvironment 
  ]
})

export class CorizeUiLibModule { }
 
 